import { createAction } from '@reduxjs/toolkit';
import {
  SET_TOURISTS,
  DELETE_SAVED_TOURIST,
  DELETE_SAVED_TOURIST_SUCCESS,
  DELETE_SAVED_TOURIST_FAIL,
} from './constants';
import type { SavedTourist } from './types';

export const setTouristsAction = createAction<SavedTourist[]>(SET_TOURISTS);
export const deleteSavedTouristAction =
  createAction<SavedTourist>(DELETE_SAVED_TOURIST);
export const deleteSavedTouristSuccessAction = createAction<number>(
  DELETE_SAVED_TOURIST_SUCCESS,
);
export const deleteSavedTouristFailAction = createAction<number | undefined>(
  DELETE_SAVED_TOURIST_FAIL,
);
